import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
import { dateFormat } from 'helpers'
import React from 'react'

const SetWeekDialog = props => {
  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={props.onCancel}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'>
        <DialogTitle>Elegir semana { props.actualWeekNumber }</DialogTitle>

        <DialogContent>

          <select name='week_filter' onChange={event => props.onOk(event.target.value)}>
            {[...Array(17)].map((val, i) => {
              return (
                <option
                  selected={props.actualWeekNumber - 1 === i}
                  key={'sem' + i} value={i + 36} classes={{ root: props.classes.menuItem }}>
                  {i + 36} ({dateFormat(props.getStartOfWeek(i + 36))} - {dateFormat(props.getEndOfWeek(i + 36))})
                </option>

              )
            })}
            {[...Array(35)].map((val, i) => {
              return (
                <option
                  selected={props.actualWeekNumber -1  === i}
                  key={'sem' + i + 'x'} value={i + 1} classes={{ root: props.classes.menuItem }}>
                  {i + 1} ({dateFormat(props.getStartOfWeek(i + 1))} - {dateFormat(props.getEndOfWeek(i + 1))})
                </option>
              )
            })}
          </select>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onCancel}>Cancelar</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>

  )
}

const styles = {
  menuItem: {
    background: 'white !important',
    color: 'black'
  }
}

export default withStyles(styles)(SetWeekDialog)



// WEBPACK FOOTER //
// ./src/components/SetWeekDialog.js